import useMenuItems from './use-menu-items';

const useActiveMenu = ({ pageId, mustHaveSubpages = false }) => {
  const { menuItems } = useMenuItems();
  if (!pageId) {
    return false;
  }

  const activeMenuItem = menuItems.find((menuItem) => {
    // am I a main page
    const isMainpage = pageId === menuItem.page?.id;
    // am I a subpage of a menu item?
    const isSubpage = menuItem.subpages.find((subpage) => subpage?.id === pageId);
    // show this menu item if mainpage with subpages,
    // or menu item contains current page as subpage
    if (isMainpage || isSubpage) {
      if (mustHaveSubpages) {
        return menuItem.subpages.length > 0;
      }
      return true;
    }
    return false;
  });

  return activeMenuItem;
};

export default useActiveMenu;
